import axios from 'axios'
import store from '@/store'

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

const VAPID_PUBLIC_KEY = process.env.PUSH_VAPID_PUBLIC_KEY
const VAPID_PUBLIC_KEY_CONVERTED = urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
const _lg = console.log

/**
 * Step four: Send the generated subscription object to our server.
 */
function sendSubscriptionToServer(subscription) {
  axios.post(
    '/messages/add-device',
    {
      user_id: store.getters['auth/profile'].userName,
      platform: 'web',
      token: subscription,
    }).then(() => {
    // _lg('Sent subscription info')
  }).catch((error) => {
    _lg('Failed to send subscription info: ', error)
  })
}

/**
 * Step three: Create a subscription. Contact the third party push server (for
 * example mozilla's push server) and generate a unique subscription for the
 * current browser.
 */
function subscribe() {
  navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
    // Contact the third party push server. Which one is contacted by
    // pushManager is  configured internally in the browser, so we don't
    // need to worry about browser differences here.
    //
    // When .subscribe() is invoked, a notification will be shown in the
    // user's browser, asking the user to accept push notifications from
    // <yoursite.com>. This is why it is async and requires a catch.
    serviceWorkerRegistration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: VAPID_PUBLIC_KEY_CONVERTED,
    })
      .then((subscription) => {
        sendSubscriptionToServer(subscription)
      })
      .catch((e) => {
        if (Notification.permission === 'denied') {
          _lg('Permission for Notifications was denied')
        } else {
          console.error('Unable to subscribe to push.', e)
        }
      })
  })
}

/**
 * Step two: The serviceworker is registered (started) in the browser. Now we
 * need to check if push messages and notifications are supported in the browser
 */
function checkPushAfterLogin() {
  // Check if desktop notifications are supported
  if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
    _lg('Notifications aren\'t supported.')
    return
  }

  // Check if user has disabled notifications
  // If a user has manually disabled notifications in his/her browser for
  // your page previously, they will need to MANUALLY go in and turn the
  // permission back on. In this statement you could show some UI element
  // telling the user how to do so.
  if (Notification.permission === 'denied') {
    _lg('The user has blocked notifications.')
    return
  }

  // Check is push API is supported
  if (!('PushManager' in window)) {
    _lg('Push messaging isn\'t supported.')
    return
  }

  navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
    // Get the push notification subscription object
    serviceWorkerRegistration.pushManager.getSubscription().then((subscription) => {
      // If this is the user's first visit we need to set up
      // a subscription to push notifications
      if (!subscription) {
        subscribe()
        return
      }

      // Update the server state with the new subscription
      sendSubscriptionToServer(subscription)
    })
      .catch((err) => {
        // Handle the error - show a notification in the GUI
        _lg('Error during getSubscription()', err)
      })
  })
    .catch((err) => {
      _lg('COULD NOT GET SUBSCRIPTION', err)
    })
}

export default checkPushAfterLogin



// WEBPACK FOOTER //
// ./src/services/web-push.js